import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d072afa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "locality-conditions" }
const _hoisted_2 = { class: "mt-2 condition-area" }
const _hoisted_3 = { class: "condition-button__text flex-grow-1" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2 text-center condition-button__count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_FormCheckboxGroup = _resolveComponent("FormCheckboxGroup")!
  const _component_SearchModal = _resolveComponent("SearchModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["condition-button", { 'is-active': _ctx.selectedCount }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenedLocalityFilter = true))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedLocalitiesLabel), 1),
          _createTextVNode(),
          (_ctx.selectedCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_ctx.selectedCount) + ")", 1))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-right",
            class: "condition-button__icon",
            size: "1x"
          })
        ], 2)
      ])
    ]),
    _createTextVNode(),
    (_ctx.isOpenedLocalityFilter)
      ? (_openBlock(), _createBlock(_component_SearchModal, {
          key: 0,
          title: "市区町村",
          onClickBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenedLocalityFilter = false)),
          onSave: _ctx.save
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormCheckboxGroup, {
              modelValue: _ctx.selectedItems,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems) = $event)),
              name: `localities-${_ctx.option.prefecture.id}`,
              options: _ctx.option.localities
            }, null, 8, ["modelValue", "name", "options"])
          ], undefined, true),
          _: 1
        }, 8, ["onSave"]))
      : _createCommentVNode("", true)
  ], 64))
}